import {
    CUSTOMER_UDFS_LOADING, CUSTOMER_UDFS_SUCCESS, CUSTOMER_UDFS_ERROR,
    RESET_CUSTOMER_UDFS
} from "../actions/actionCustomerUDFs";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "customerUdfs";

const initialState = {
    customerUDFs: loadState(sessionKey1, []),
    loading: false,
    customerUDFError: ''
};

function reducerCustomerUDFs(state = initialState, action) {

    switch (action.type) {

        case CUSTOMER_UDFS_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case CUSTOMER_UDFS_SUCCESS: {

            saveState(sessionKey1, action.payload);

            return {
                ...state,
                loading: false,
                customerUDFs: action.payload,
                customerUDFError: ''
            };
        }

        case CUSTOMER_UDFS_ERROR: {

            saveState(sessionKey1, []);

            return {
                ...state,
                loading: false,
                customerUDFs: [],
                customerUDFError: action.error
            }
        }

        case RESET_CUSTOMER_UDFS: {

            saveState(sessionKey1, []);

            return {
                ...state,
                loading: false,
                customerUDFs: [],
                customerUDFError: ''
            };
        }

        default: {
            return state;
        }
    }
}

export default reducerCustomerUDFs;